<template>
    <v-row no-gutters class="pr-2">
        <v-col
            v-for="id in possibleToolbarIds"
            :key="id"
            cols="auto"
        >
            <div v-show="showToolbar(id)">
                <RichTextEditorToolbarWrapper
                    :include-link="true"
                    :include-text-size="true"
                    :toolbar-id="getToolbarId(id)"
                />
            </div>
        </v-col>

        <v-col v-if="!disabled" cols="auto">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <div class="d-inline" v-on="on">
                        <RichTextEditorPlaceholders
                            :company-id="24778"
                            :placeholder-types="placeholderTypes"
                            @placeholder="$emit('placeholder', $event)"
                        />
                    </div>
                </template>
                <span>{{ $t("Add placeholder") }}</span>
            </v-tooltip>
        </v-col>
        <v-col v-if="!disabled" cols="auto">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <icon-button :icon-size="24" :on="on" @click="toggleColorPicker()">
                        mdi-palette-outline
                    </icon-button>
                </template>
                {{ $t('Font color') }}
            </v-tooltip>
            <color-picker
                :show="showColorPicker"
                :color="currentColor"
                :on-select="(color) => pickColor(color)"
                @close="toggleColorPicker()"
            />
        </v-col>
        <v-col v-if="!disabled" cols="auto">
            <action-menu
                :tooltip="$t('Actions')"
                :items="actionItems"
                :absolute="false"
                :open-menu-right="true"
                :open-menu-below="true"
                @action="actionItems[$event].action()"
            />
        </v-col>
        <v-col cols="auto" class="ml-auto">
            <action-button
                :icon="null"
                @click="$emit('sendTestEmail')"
            >
                {{ $t('Send test email') }}
            </action-button>
            <secondary-button @click="$emit('cancelModal')">
                {{ $t("Cancel") }}
            </secondary-button>
            <primary-button
                :disabled="disabled"
                @click="$emit('save')"
            >
                {{ $t("Save") }}
            </primary-button>
        </v-col>
    </v-row>

</template>

<script>
import RichTextEditorToolbarVue from "../../../components/RichTextEditor/RichTextEditorToolbar.vue";
import RichTextEditorToolbarWrapper from "./RichTextEditorToolbarWrapper.vue";
import {ref, computed} from "@vue/composition-api";
import ColorPicker from "../../../components/ColorPicker.vue";
import {$t} from "../../../i18n";
import RichTextEditorPlaceholders from "../../../components/RichTextEditor/RichTextEditorPlaceholders.vue";
import ApiEmailAutomationPlaceholders from "../../../api/email_automation/placeholders";

export default {
    name: "SignatureFooter",
    components: {RichTextEditorPlaceholders, ColorPicker, RichTextEditorToolbarWrapper, RichTextEditorToolbarVue},
    props: {
        activeRichTextEditorId: {
            type: Number,
            default: 0
        },
        activeRichTextEditor: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    setup(props, ctx) {
        const possibleToolbarIds = ref([0, 1, 2])
        const showColorPicker = ref(false)
        const currentColor = ref(null)
        const { getPlaceholderTypes } = ApiEmailAutomationPlaceholders

        const placeholderTypes = computed(() => {
            return getPlaceholderTypes("signature")
        })

        const actionItems = computed(() => {
            return [
                {
                    text: $t("Delete signature"),
                    action: () => ctx.emit('deleteSignature')
                }
            ]
        })

        const getToolbarId = (id) => {
            return `email-signature-toolbar-${id}`
        }

        const showToolbar = (id) => {
            return id === props.activeRichTextEditorId && !props.disabled
        }

        const toggleColorPicker = () => {
            showColorPicker.value = !showColorPicker.value
        }

        const pickColor = (value) => {
            if (props.activeRichTextEditor) {
                const quill = props.activeRichTextEditor.$refs.richTextEditorContent.quill
                if (quill) {
                    quill.format('color', value);
                }
            }
            currentColor.value = value

        }

        return {
            getToolbarId,
            showToolbar,
            toggleColorPicker,
            pickColor,
            placeholderTypes,
            actionItems,
            showColorPicker,
            possibleToolbarIds,
            currentColor,
        }
    }
}
</script>

<style scoped lang="scss">

</style>